import useAgeGate from './hooks/useAgeGate';
import AgeGatePanel from './components/AgeGatePanel';
import { AgeGateCard, AgeGateOverlay } from './AgeGate.styles';

const AgeGate = ({ children }) => {
	const { t, isConfirmed, isBlocked, handleConfirm, handleDecline } =
		useAgeGate();

	if (isConfirmed) {
		return children;
	}

	return (
		<AgeGateOverlay role="dialog" aria-modal="true" aria-labelledby="age-gate-title">
			<AgeGateCard>
				<AgeGatePanel
					translations={t}
					isBlocked={isBlocked}
					onConfirm={handleConfirm}
					onDecline={handleDecline}
				/>
			</AgeGateCard>
		</AgeGateOverlay>
	);
};

export default AgeGate;
